"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.object.assign.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidBirthdate = exports.default = exports.OwnerBirthdate = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _InputText = require("../../InputText");
var _NativeDateCalendarPopupTrigger = require("./NativeDateCalendarPopupTrigger");
var _ageHelpers = require("../../../../../helpers/ageHelpers");
var _propTypes = require("../../../../../propTypes");
const _excluded = ["fieldFormContext", "minAgeInDays", "maxAgeInDays"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Validates the birthdate of the owner to ensure it is within the minimum and maximum age limits.
 *
 * @param dateString {string} The birthdate of the owner.
 * @param minDateTimestamp {number} The date of minimum age timestamp
 * @param maxDateTimestamp {number} The date of maximum age timestamp
 * @param clearErrors {function} The function to clear errors
 * @param name {string} The name of the field
 * @returns {string|boolean} Returns true if the birthdate is valid, otherwise returns an error message
 */
const isValidBirthdate = (dateString, minDateTimestamp, maxDateTimestamp, clearErrors, name) => {
  // Make sure they have finished filling in the pieces
  if (!(0, _ageHelpers.IsDateEntryComplete)({
    dateString
  })) {
    return true;
  }
  const {
    minDateValid,
    maxDateValid
  } = (0, _ageHelpers.ValidateBirthdate)({
    birthdateString: dateString,
    minDateTimestamp: (0, _ageHelpers.getInclusiveMinAgeDateTimestamp)(minDateTimestamp),
    maxDateTimestamp
  });
  if (!maxDateValid) {
    return 'We think this is an error as the oldest recorded human is 112 years of age.';
  }
  if (!minDateValid) {
    return 'You must be over 18 years to apply for pet insurance.';
  }
  clearErrors(name);
  return true;
};
exports.isValidBirthdate = isValidBirthdate;
const OwnerBirthdate = _ref => {
  let {
      fieldFormContext,
      minAgeInDays = 6574,
      // 18 years in days
      maxAgeInDays = 40908 // 112 years in days
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const hookFormContext = (0, _reactHookForm.useFormContext)();
  const formContext = fieldFormContext || hookFormContext;
  const {
    clearErrors
  } = formContext;
  const {
    isoMinDate,
    minDateTimestamp,
    isoMaxDate,
    maxDateTimestamp
  } = (0, _ageHelpers.GetMinAndMaxAges)({
    minAgeInDays: minAgeInDays + 1,
    maxAgeInDays
  });
  const customValidation = _objectSpread(_objectSpread({}, rest.validation), {}, {
    validate: _objectSpread(_objectSpread({}, rest.validation && rest.validation.validate), {}, {
      min: dateString => isValidBirthdate(dateString, minDateTimestamp, maxDateTimestamp, clearErrors, rest.name),
      max: dateString => isValidBirthdate(dateString, minDateTimestamp, maxDateTimestamp, clearErrors, rest.name)
    }),
    valueAsDate: true
  });
  return /*#__PURE__*/_react.default.createElement(_InputText.InputText, _extends({
    inputType: "date"
  }, rest, {
    min: isoMaxDate,
    max: isoMinDate,
    fieldFormContext: formContext,
    validation: customValidation,
    customCssClass: "nativeDateInput",
    customPostInputContent: /*#__PURE__*/_react.default.createElement(_NativeDateCalendarPopupTrigger.NativeDateCalendarPopupTrigger, {
      dateInputElementId: rest.id || rest.name,
      readOnly: rest.readOnly || false
    })
  }));
};
exports.OwnerBirthdate = OwnerBirthdate;
OwnerBirthdate.propTypes = _propTypes.FormFieldPropTypes;
var _default = exports.default = OwnerBirthdate;